// extracted by mini-css-extract-plugin
export var currentPage = "blog-module--current-page--dafdb";
export var next = "blog-module--next--73874";
export var pageNav = "blog-module--page-nav--2f2df";
export var pageNavBar = "blog-module--page-nav-bar--8a688";
export var pagination = "blog-module--pagination--04afe";
export var post = "blog-module--post--bb6f5";
export var postBox = "blog-module--post-box--c1581";
export var postDateText = "blog-module--post-date-text--e8190";
export var postPreviewText = "blog-module--post-preview-text--b06e1";
export var postPreviewTextInner = "blog-module--post-preview-text-inner--0c278";
export var postText = "blog-module--post-text--e683e";
export var postThumbnail = "blog-module--post-thumbnail--cfe20";
export var posts = "blog-module--posts--682b0";
export var readMore = "blog-module--read-more--0c1e4";
export var tagHeading = "blog-module--tag-heading--7d112";
export var tagged = "blog-module--tagged--36cdc";